export default function IconQuotes() {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 31 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.96 20.76C22.88 20.76 21.2267 19.96 20 18.36C18.7733 16.76 18.16 14.8933 18.16 12.76C18.16 7.48 21.3867 3.24 27.84 0.039999L30 3.48C29.6267 3.69333 28.9867 4.14667 28.08 4.84C27.2267 5.48 26.2933 6.46666 25.28 7.8C24.32 9.13333 23.8933 10.36 24 11.48C24.4267 11.0533 25.0933 10.84 26 10.84C27.3333 10.84 28.3733 11.2933 29.12 12.2C29.8667 13.1067 30.24 14.2267 30.24 15.56C30.24 17.0533 29.7067 18.3067 28.64 19.32C27.6267 20.28 26.4 20.76 24.96 20.76ZM7.6 20.76C5.52 20.76 3.86667 19.96 2.64 18.36C1.41333 16.76 0.8 14.8933 0.8 12.76C0.8 7.48 4.02667 3.24 10.48 0.039999L12.64 3.48C12.2667 3.69333 11.6267 4.14667 10.72 4.84C9.86667 5.48 8.93333 6.46666 7.92 7.8C6.96 9.13333 6.53333 10.36 6.64 11.48C7.06667 11.0533 7.73333 10.84 8.64 10.84C9.97333 10.84 11.0133 11.2933 11.76 12.2C12.5067 13.1067 12.88 14.2267 12.88 15.56C12.88 17.0533 12.3467 18.3067 11.28 19.32C10.2667 20.28 9.04 20.76 7.6 20.76Z"
        fill="#030303"
      />
    </svg>
  )
}
